import { element } from 'protractor';


import {
  Component, OnInit, ViewChild,
  ElementRef, AfterViewInit, Renderer2,
  HostListener, Input, Output, OnChanges,
  SimpleChange, SimpleChanges,
  QueryList,
  ViewChildren,
  ChangeDetectorRef
} from '@angular/core';
import { HtmlParser } from '@angular/compiler';
import { CarouselComponent } from 'angular-responsive-carousel';
import { ApiService } from 'src/app/services/api.service';
import { DomSanitizer } from '@angular/platform-browser';
import { debug } from 'console';
import { UtilitiesService } from 'src/app/services/utilities.service';
declare var $: any;

@Component({
  selector: 'app-offers',
  templateUrl: './offers.component.html',
  styleUrls: ['./offers.component.css'],
  styles: [`
      ::ng-deep .offer-gallery .carousel-arrow-next{
          right: -20px !important;
      }

      ::ng-deep .offer-gallery .carousel-arrow-prev{
          left: -20px !important;
      }
  `]
})
export class OffersComponent implements OnInit, OnChanges {

  @ViewChild("offerGallery") offerGallery!: ElementRef;
  @ViewChild('carouselCell', { static: false }) carouselCell!: ElementRef;
  iframeHeight: string = '100%';
  private slickInitialized = false;

  //images: any[] = [];
  bannersLoaded = 0;
  @Input('images') images: any[] = [
    {
      "src": "https://d3cqf5kijn47yv.cloudfront.net/offer-banners/4329.jpg"
    },
    {
      "src": "https://d3cqf5kijn47yv.cloudfront.net/offer-banners/Legion%205i%20Pro_1284x896_300%20Dpi.png"
    }
  ];
  @Input('height') height: number = 300;
  @Input('width') width: number = 400;
  @ViewChild("innerOffersCaraousel") innerOffersCaraousel?: CarouselComponent
  bannerImages: any[] = [];
  slider: any;
  previousSlideIndex: any;
  isFullscreen: boolean = false;
  currIndex: any;
  currentIndex: number = 0;
  currentBanner: any;

  constructor(private apiService: ApiService, private renderer: Renderer2,private domSanitizer: DomSanitizer,
    private cdr: ChangeDetectorRef, public utily: UtilitiesService
  ) { }

//   ngOnInit(): void {

//     console.log("this.images ", this.images);
//     this.monitorFullscreen();
//     /* this.apiService.getBannerImages(this.forLandingPage).then(result => {
//       //this.reInitOffersGallery();
//       this.banners = result.adminbannerimages;
//       //this.renderer.setStyle(this.offerGallery.nativeElement, 'display', 'block');

//       //this.showBanners();

//     }); */

//     /* $('.offers-carousel').click(() => {
      
//     }); */
//   }

//   ngAfterViewInit(): void {
//     this.disableResizeReset();
//   }
  


//   showPage(ev: any) {
//     if ($(ev.target).hasClass('carousel-arrow')) { 
//       return;
//     }
//     if(!this.isFullscreen){
//     const url = this.images[this.getCurrentSlide()].url;
//     if (url) {
//       window.open(url, '_blank');
//     }
//    }
//   }

//   ngOnChanges(changes: SimpleChanges) {
//     let counter = 0;
//     for (let property in changes) {
//       if (property === 'images') {
//         this.bannerImages = [];
//         $('#thumb-list_holder').html('');
//         for (let img of this.images) {
//           this.bannerImages.push({ path: img.src, alt: img.image_alt_text , type: img.type });
//           $('#thumb-list_holder').append(`<li>
//           <a href="javascript:" id="offer_thumb_id_`+ (counter++) + `">
//               <img src="`+ img.src + `"   width="100%" height="auto" alt="` + img.image_alt_text + `" class="img-fluid">
//           </a>
//           </li>`);
//         }
//       }
//     }

//     this.bannerImages = this.bannerImages.map(item => ({
//       ...item,
//       transformedPath: this.transform(item.path) 
//   }));

//   this.cdr.detectChanges();
//   }

//   ngDoCheck(): void {
//     const currentSlideIndex = this.getCurrentSlide();
//     if (!this.isFullscreen && currentSlideIndex !== this.previousSlideIndex) {
//       this.onSlideChange();
//       this.previousSlideIndex = currentSlideIndex;
//     }
//   }

//   disableResizeReset(): void {
//     if (this.innerOffersCaraousel) {
//       this.innerOffersCaraousel.onWindowResize = (event) => {
//         console.log('Window resized but no reset occurred');
//       };
//     } else {
//       console.error('Carousel instance is not ready yet');
//     }
//     this.cdr.detectChanges();
//   }
  

//   getCurrentSlide() {
//     return this.innerOffersCaraousel?.slideCounter;
//   }

//   nextSlide() {
//     this.innerOffersCaraousel?.next();
//   }

//   prevSlide() {
//     this.innerOffersCaraousel?.prev();
//   }
//   //Sample

//   canShowImage(item: any) {
//     return item && item.path && item.type == 'img';
//   }

//   canShowVideo(item: any) {
//     return item && item.path && item.type == 'video';
//   }

//   transform(url: any) {
//     return this.domSanitizer.bypassSecurityTrustResourceUrl(url);
//   }

//   trackById(index: number, item: any): any {
//     return item.id;
//   }

//   onSlideChange(): void {

//     if (typeof document.fullscreenElement !== "undefined" && this.isFullscreen) {
//       console.log("Skipping slide change during fullscreen mode.");
//       return;
//     }
//     if(!this.isFullscreen){
//      var videoUrl = $(".iframevideo").prop('src');
//      videoUrl = videoUrl.replace("&autoplay=1", "");
//      $(".iframevideo").prop('src', '');
//      $(".iframevideo").prop('src', videoUrl);
//     }
//   }

//   autoPlay = true;
//   isPlaying = false;
//   playVideo() {
//     this.currIndex = this.innerOffersCaraousel?.activeDotIndex;
//     if (!this.isPlaying) {
//       var videoUrl = $(".iframevideo").prop('src');
//       videoUrl += "&autoplay=1";
//       $(".iframevideo").prop('src', videoUrl);
//       this.isPlaying = true;
//     } else {
//       var videoUrl = $(".iframevideo").prop('src');
//       videoUrl = videoUrl.replace("&autoplay=1", "");
//       $(".iframevideo").prop('src', '');
//       $(".iframevideo").prop('src', videoUrl);
//       this.isPlaying = false;
//     }
//     this.cdr.detectChanges();
    

//   }

// monitorFullscreen(): void {
//   document.addEventListener('fullscreenchange', () => {
//     setTimeout(() => {     
//       console.log("fullscreen");
//       this.isFullscreen = !!document.fullscreenElement;
//       this.disableResizeReset();
//       if (!this.isFullscreen) {
//         this.disableResizeReset();
//       }
//       this.cdr.detectChanges();
//     }, 100);
//   });
// }




  ngOnChanges(changes: SimpleChanges) {
    let counter = 0;
    for (let property in changes) {
        if (property === 'images') {
          this.bannerImages = [];
          this.caroselRender(this.images);
        }
    }
    this.cdr.detectChanges();
  }

  pauseOnHover: boolean = true;
  interval: any; 
  ngAfterViewInit() {
    this.cdr.detach();
    this.pauseOnHover = window.innerWidth < 768 ? false : true;
    this.handleSilder();
  }
  
  handleSilder() {
    setInterval(() => {
      let slider: number = this.getCurrentSlide();
      let imageLength = this.images.length - 1;
      if (slider == imageLength) {
          if (!this.isPlaying) this.innerOffersCaraousel?.carousel.prev(slider);
      } else {
          if (!this.isPlaying) this.innerOffersCaraousel?.carousel.next(slider + 1);
        }
    }, this.interval)
  }
  
  onIframeLoad(event: any) {
      const carouselCellHeight = this.carouselCell.nativeElement.offsetHeight;
      this.iframeHeight = `${carouselCellHeight}px`;
      let iframe = event.target as HTMLIFrameElement;
      if (iframe != null)
        iframe.style.height = this.iframeHeight;
  }
  
  
  ngOnInit(): void {
      this.cdr.detectChanges();
      this.utily.banners.subscribe(val => {
        this.images = val;
        this.caroselRender(this.images);
        this.cdr.detectChanges(); 
      })
  }
  
  autoPlay = true;
  isPlaying = false;
  playVideo() {
    if (!this.isPlaying) {
      var videoUrl = $(".iframe").prop('src');
      videoUrl += "&autoplay=1";
      $(".iframe").prop('src', videoUrl);
      this.isPlaying = true;
      this.autoPlay = false;
    } else {
        var videoUrl = $(".iframe").prop('src');
        videoUrl = videoUrl.replace("&autoplay=1", "");
        $(".iframe").prop('src', '');
        $(".iframe").prop('src', videoUrl);
        this.autoPlay = false;
        this.isPlaying = false;
      }  
    }
  
  caroselRender(images: any) {
    let counter = 0;
    this.bannerImages = [];
    for (let img of images) {
        this.bannerImages.push({ path: img.src, alt: img.image_alt_text, type: img.type });
    }
    this.currentBanner = this.bannerImages[0];
  }
  
  canShowImage(item: any) {
      return item && item.path && item.type == 'img';
  }
  
  canShowVideo(item: any) {
      return item && item.path && item.type == 'video';
  }
  
  transform(url: any) {
      return this.domSanitizer.bypassSecurityTrustResourceUrl(url);
  }
  
  showPage(ev: any) {
      if ($(ev.target).hasClass('carousel-arrow')) {
        return;
      }
      const url = this.images[this.getCurrentSlide()].url;
      if (url) {
        window.open(url, '_blank');
      }
  }
  
  
  
  getCurrentSlide(): number {
    return this.innerOffersCaraousel?.slideCounter;
  }
  
  nextSlide() {
    this.innerOffersCaraousel?.next();
  }
  
  prevSlide() {
    this.innerOffersCaraousel?.carousel.prev(0);
  }

  nextMainBanner() {
    if (this.currentIndex < this.bannerImages.length - 1) {
        this.currentIndex++;
        this.currentBanner = this.bannerImages[this.currentIndex];
        this.cdr.detectChanges();
      }
  }
  
  prevMainBanner() {
      if (this.currentIndex > 0) {
        this.currentIndex--;
        this.currentBanner = this.bannerImages[this.currentIndex];
        this.cdr.detectChanges();
      }
  }


}
 